import { Button } from "@/components/ui/button.tsx";
import { cn } from "cn";

export interface ResetFiltersButtonProps {
    isActive: boolean;
    onReset: () => void;
    label: string;
    className?: string;
}

export function ResetFiltersButton({ isActive, onReset, label, className }: ResetFiltersButtonProps) {
    if (!isActive) {
        return null;
    }

    return (
        <Button intent="plain" size="sm" onPress={onReset} className={cn("text-muted-fg hover:text-fg shrink-0", className)}>
            {label}
        </Button>
    );
}
